import React, { useEffect, useRef, useState } from 'react';
// Uncomment if/when we'll use GraphQL again for the API calls
// import { useMutation } from '@apollo/client';
import Lottie from 'lottie-react';

import DeleteModal from '@atom/components/common/DeleteModal';
// @ts-ignore
import aiChatbotIcon from '@atom/components/common/svgIcons/aiChatbot.svg';
import animationData from '@atom/components/common/svgIcons/aiChatbotAnimatedButton.json';
// @ts-ignore
import betaLabel from '@atom/components/common/svgIcons/betaLabel.svg';
// @ts-ignore
import clearHistoryIcon from '@atom/components/common/svgIcons/clearHistory.svg';
// @ts-ignore
import thumbDown from '@atom/components/common/svgIcons/thumbDown.svg';
// @ts-ignore
import thumbDownOffAlt from '@atom/components/common/svgIcons/thumbDownOffAlt.svg';
// @ts-ignore
import thumbUp from '@atom/components/common/svgIcons/thumbUp.svg';
// @ts-ignore
import thumbUpOffAlt from '@atom/components/common/svgIcons/thumbUpOffAlt.svg';
// import { ASK_QUESTION, RATE_ANSWER } from '@atom/graph/ai';
import { useUserProfile } from '@atom/hooks/useUserProfile';
import { Button, Icon, IconButton, Snackbar, TextField } from '@atom/mui';
/*
import {
  Answer,
  AskQuestionInput,
  ChatEntry,
  RateAnswerInput,
  Rating,
} from '@atom/types/ai';
*/
import api from '@atom/utilities/api';
import { AI_ASK_ENDPOINT, AI_RATE_ENDPOINT } from '@atom/utilities/endpoints';

import './aiChatbotDrawer.css';

interface Props {
  onClose: () => void;
}

const AIChatbotDrawer = ({ onClose }: Props) => {
  const [question, setQuestion] = useState('');
  // const [chatHistory, setChatHistory] = useState<ChatEntry[]>([]);
  const [chatHistory, setChatHistory] = useState([]);
  const [sessionId, setSessionId] = useState<string>('');
  const [feedbackIndex, setFeedbackIndex] = useState<number | null>(null);
  const [feedbackText, setFeedbackText] = useState('');
  const [isClearHistoryModalOpen, setIsClearHistoryModalOpen] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false); // set to true, to show them
  const [delayedSubmit, setDelayedSubmit] = useState(false);
  const [askLoading, setAskLoading] = useState(false);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const userProfile = useUserProfile();

  const askQuestion = async body => {
    try {
      setAskLoading(true);
      const { data } = await api.post(AI_ASK_ENDPOINT, { ...body });
      setAskLoading(false);
      setChatHistory(prev => [
        ...prev.slice(0, -1),
        {
          question,
          answer: data.answer,
          rating: null,
          feedback: null,
          timestamp: Date.now(),
        },
      ]);
      setSessionId(data.sessionId);
      setQuestion('');
      setShowSuggestions(false);
    } catch (error) {
      setAskLoading(false);
      setChatHistory(prev => [
        ...prev.slice(0, -1),
        {
          question,
          answer: 'There was an error while retrieving the answer',
          rating: null,
          feedback: null,
          timestamp: Date.now(),
        },
      ]);
      Snackbar.error({
        message: 'Error submitting question',
      });
    }
  };

  /*
  const [askQuestion, { loading: askLoading, error: askError }] = useMutation<
    { askQuestion: Answer },
    { input: AskQuestionInput }
  >(ASK_QUESTION, {
    onCompleted: data => {
      setChatHistory(prev => [
        ...prev.slice(0, -1),
        {
          question,
          answer: data.askQuestion.answer,
          rating: null,
          feedback: null,
          timestamp: Date.now(),
        },
      ]);
      setSessionId(data.askQuestion.sessionId);
      setQuestion('');
      setShowSuggestions(false);
    },
    onError: () => {
      Snackbar.error({
        message: 'Error submitting question',
      });
    },
  });
*/

  const rateAnswer = async body => {
    try {
      const { data } = await api.post(AI_RATE_ENDPOINT, { ...body });
      if (data.status === 'success' && feedbackIndex !== null) {
        setChatHistory(prev =>
          prev.map((entry, index) =>
            index === feedbackIndex
              ? {
                  ...entry,
                  rating: prev[index].rating,
                  feedback: feedbackText || null,
                }
              : entry,
          ),
        );
      }
      setFeedbackText('');
    } catch (error) {
      Snackbar.error({
        message: 'Error submitting feedback',
      });
    }
  };

  /*
  const [rateAnswer, { error: rateError }] = useMutation<
    { rateAnswer: Rating },
    { input: RateAnswerInput }
  >(RATE_ANSWER, {
    onCompleted: data => {
      if (data.rateAnswer.status === 'success' && feedbackIndex !== null) {
        setChatHistory(prev =>
          prev.map((entry, index) =>
            index === feedbackIndex
              ? {
                  ...entry,
                  rating: prev[index].rating,
                  feedback: feedbackText || null,
                }
              : entry,
          ),
        );
      }
      setFeedbackIndex(null);
      setFeedbackText('');
    },
    onError: () => {
      Snackbar.error({
        message: 'Error submitting feedback',
      });
    },
  });
  */
  /*
  useEffect(() => {
    if (askError) {
      Snackbar.error({ message: askError.message });
    }
    if (rateError) {
      Snackbar.error({ message: rateError.message });
    }
  }, [askError, rateError]);
*/

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!question.trim()) {
      return;
    }

    setChatHistory(prev => [
      ...prev,
      {
        question,
        answer: null,
        rating: null,
        feedback: null,
        timestamp: Date.now(),
      },
    ]);

    askQuestion({
      //      variables: {
      //        input: {
      question,
      sessionId: sessionId || undefined,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      //        },
      //      },
    });
    setShowSuggestions(false);
  };

  useEffect(() => {
    if (delayedSubmit) {
      setDelayedSubmit(false);
      handleSubmit(new Event('submit') as any);
      setShowSuggestions(false);
    }
  }, [delayedSubmit]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit(event as any);
    }
  };

  const handleCopyToClipboard = (text: string) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          Snackbar.info({ message: 'Copied' });
        })
        .catch(error => {
          Snackbar.error({ message: 'Copy failed' });
        });
    } else {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        Snackbar.info({ message: 'Copied' });
      } catch (error) {
        Snackbar.error({ message: 'Copy failed' });
      }
    }
  };

  const handleRatingClick = (index: number, rating: string) => {
    const currentRating = chatHistory[index].rating;
    const newRating = currentRating === rating ? null : rating;

    setChatHistory(prev =>
      prev.map((entry, ndx) =>
        ndx === index ? { ...entry, rating: newRating } : entry,
      ),
    );

    if (newRating) {
      rateAnswer({
        //          variables: {
        //            input: {
        sessionId,
        answerIndex: index,
        rating: newRating,
        feedback: null,
        //            },
        //          },
      });
      setFeedbackIndex(prev => index);
      setFeedbackText(chatHistory[index].feedback || '');
    } else {
      rateAnswer({
        //          variables: {
        //            input: {
        sessionId,
        answerIndex: index,
        rating: null,
        feedback: null,
        //            },
        //          },
      });
      setFeedbackIndex(null);
      setFeedbackText('');
    }
  };

  const handleFeedbackSubmit = (index: number) => {
    if (!sessionId) {
      Snackbar.error({ message: 'No session ID available' });
      return;
    }

    setChatHistory(prev =>
      prev.map((entry, ndx) =>
        ndx === index ? { ...entry, feedback: feedbackText } : entry,
      ),
    );
    rateAnswer({
      //      variables: {
      //        input: {
      sessionId,
      answerIndex: index,
      rating: chatHistory[index].rating || undefined,
      feedback: feedbackText.trim() || undefined,
      //        },
      //      },
    });
    setFeedbackIndex(null);
    setFeedbackText('');
    Snackbar.info({ message: 'Thank you for your feedback!' });
  };

  const handleFeedbackCancel = () => {
    setFeedbackIndex(null);
    setFeedbackText('');
  };

  const handleSuggestionClick = (suggestion: string) => {
    setQuestion(suggestion);
    setDelayedSubmit(true);
  };

  const handleClearHistoryConfirm = () => {
    setChatHistory([]);
    setQuestion('');
    setFeedbackIndex(null);
    setFeedbackText('');
    setSessionId('');
    setIsClearHistoryModalOpen(false);
    // We are not showing the suggestions for now.
    // setShowSuggestions(true);
  };

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory]);

  return (
    <div styleName="drawer-container">
      <div styleName="drawer-content-wrapper">
        <div styleName="drawer-content">
          <div styleName="drawer-header">
            <div styleName="header-frame">
              <div styleName="header-title">
                <h6 styleName="typography-root typography-h6">Atom AI</h6>
                <img src={betaLabel} alt="BETA" styleName="beta-label" />
              </div>
              <span styleName="small-text">Powered by Gemini.</span>
            </div>
            <div styleName="header-actions">
              <IconButton
                size="small"
                onClick={() => setIsClearHistoryModalOpen(true)}
                styleName="clear-history-button"
                tooltip="Clear history"
                disabled={chatHistory.length === 0}
              >
                <img src={clearHistoryIcon} alt="Clear history" />
              </IconButton>
              <IconButton size="small" onClick={onClose}>
                <Icon>close</Icon>
              </IconButton>
            </div>
          </div>
          <div ref={chatContainerRef} styleName="chat-container">
            <div styleName="answer-row">
              <img src={aiChatbotIcon} alt="ATOM AI" styleName="answer-icon" />
              <div styleName="answer-content">
                <p styleName="typography-root typography-body1">
                  {userProfile?.firstName}, welcome! I'm Atom AI, feel free to
                  ask me anything about what's happening in Atom. How can I
                  help?
                </p>
                {showSuggestions && (
                  <>
                    <Button
                      size="small"
                      styleName="suggestion-button"
                      onClick={() =>
                        handleSuggestionClick(
                          'Is there any open work for me today?',
                        )
                      }
                      startIcon={<Icon>arrow_forward</Icon>}
                    >
                      Is there any open work for me today?
                    </Button>
                    <Button
                      size="small"
                      styleName="suggestion-button"
                      onClick={() =>
                        handleSuggestionClick(
                          'Which open work has the highest priority?',
                        )
                      }
                      startIcon={<Icon>arrow_forward</Icon>}
                    >
                      Which open work has the highest priority?
                    </Button>
                    <Button
                      size="small"
                      styleName="suggestion-button"
                      onClick={() =>
                        handleSuggestionClick(
                          'What is the current stock level for inventory?',
                        )
                      }
                      startIcon={<Icon>arrow_forward</Icon>}
                    >
                      What is the current stock level for inventory?
                    </Button>
                  </>
                )}
              </div>
            </div>
            {chatHistory.map((entry, index: number) => (
              <div key={index}>
                <div styleName="question-row">
                  <div styleName="question-bubble">{entry.question}</div>
                </div>
                <div styleName="answer-row">
                  {askLoading && index === chatHistory.length - 1 ? (
                    <Lottie
                      animationData={animationData}
                      loop
                      autoplay
                      style={{ height: '32px', width: '32px' }}
                      className="answer-icon"
                    />
                  ) : (
                    <img
                      src={aiChatbotIcon}
                      alt="ATOM AI"
                      styleName="answer-icon"
                    />
                  )}
                  <div styleName="answer-content">
                    <div>
                      {entry.answer
                        ? entry.answer
                        : askLoading &&
                          index === chatHistory.length - 1 && (
                            <p styleName="typography-root typography-body2">
                              Thinking...
                            </p>
                          )}
                    </div>
                    {entry.answer && (
                      <div styleName="feedback-icons">
                        <IconButton
                          onClick={() => handleCopyToClipboard(entry.answer)}
                          styleName="feedback-icon"
                          tooltip="Copy answer to clipboard"
                        >
                          <Icon>content_copy_outlined</Icon>
                        </IconButton>
                        <IconButton
                          onClick={() => handleRatingClick(index, 'positive')}
                          styleName={`feedback-icon ${
                            entry.rating === 'positive' ? 'active' : ''
                          }`}
                          tooltip="Good response"
                        >
                          <img
                            src={
                              entry.rating === 'positive'
                                ? thumbUp
                                : thumbUpOffAlt
                            }
                            alt="Thumb up"
                          />
                        </IconButton>
                        <IconButton
                          onClick={() => handleRatingClick(index, 'negative')}
                          styleName={`feedback-icon ${
                            entry.rating === 'negative' ? 'active' : ''
                          }`}
                          tooltip="Bad response"
                        >
                          <img
                            src={
                              entry.rating === 'negative'
                                ? thumbDown
                                : thumbDownOffAlt
                            }
                            alt="Thumb down"
                          />
                        </IconButton>
                      </div>
                    )}
                    {feedbackIndex === index && (
                      <div styleName="feedback-container">
                        <div styleName="feedback-content">
                          <div styleName="feedback-title">
                            {entry.rating === 'positive'
                              ? 'Thanks for your rating'
                              : 'Help us improve'}
                          </div>
                          <div styleName="typography-root typography-body2 feedback-prompt">
                            {entry.rating === 'positive'
                              ? "We'd love to hear what you liked about this response."
                              : 'Your feedback helps us make Atom AI work better for you.'}
                          </div>
                          <TextField
                            fullWidth
                            value={feedbackText}
                            onChange={event =>
                              setFeedbackText(event.target.value)
                            }
                            placeholder="Provide additional feedback (optional)"
                            variant="outlined"
                            size="small"
                            styleName="feedback-input"
                          />
                          <div styleName="feedback-actions">
                            <Button
                              onClick={handleFeedbackCancel}
                              variant="text"
                              styleName="feedback-cancel"
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={() => handleFeedbackSubmit(index)}
                              variant="contained"
                              styleName="feedback-submit"
                              disabled={!feedbackText.trim()}
                            >
                              Submit
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div styleName="input-section">
            <form onSubmit={handleSubmit} styleName="input-wrapper">
              <textarea
                rows={2}
                placeholder="Ask Atom AI a question"
                value={question}
                onChange={event => setQuestion(event.target.value)}
                onKeyDown={handleKeyDown}
                styleName={`chat-input ${question.trim() ? 'active' : ''}`}
                disabled={askLoading}
              />
              <IconButton
                size="small"
                type="submit"
                styleName={`send-button ${question.trim() ? 'active' : ''}`}
                disabled={askLoading}
              >
                <Icon styleName="send-icon">arrow_upward</Icon>
              </IconButton>
            </form>
            <span styleName="small-text">
              Atom AI can make mistakes. Please verify ANY important
              information.
            </span>
          </div>
        </div>
      </div>
      <DeleteModal
        title="Clear History?"
        confirmText="Clear"
        onConfirm={handleClearHistoryConfirm}
        onCancel={() => setIsClearHistoryModalOpen(false)}
        open={isClearHistoryModalOpen}
        content={
          <div styleName="clear-history-modal-container">
            History with Atom AI will be cleared and you won't be able to get it
            back.
          </div>
        }
      />
    </div>
  );
};

export default AIChatbotDrawer;
